<template>
  <div class="login-buttons-wrap  ">
    <div
      v-if="originOfClient === 'IL' || lang === 'he'"
      class="lite-lp-popup-buttons-wrap"
    >
     <div class="button-wrap">
       <button
         class="lite-lp-popup-moe-btn"
         @click="goToIdmSso"
         :data-text="$t('UNIFORM_LOGIN')"
       >
         <img
           src="@/assets/images/eduLogo.png"
           alt="edu-logo"
           class="edu-logo"
         />
       </button>
       <a  @click="goToIdmSso" class="text-url">
         {{$t('UNIFORM_LOGIN')}}
       </a>
     </div>
      <div class="button-wrap">
        <button
          class="lite-lp-popup-google-btn"
          @click="goToGoogleSso"
          :data-text="$t('GOOGLE_LOGIN')"
        >
          <span id="google-login-btn" class="button-wrap">
            <a class="google-design">
              <img
                src="@/assets/images/google-icon.svg"
                alt="google logo"
                class="google-logo"
              />
            </a>
             <a class="text-url">
                {{$t('GOOGLE_LOGIN')}}
              </a>
          </span>
        </button>
      </div>
    </div>
    <div v-else @click="goToGoogleSso">
      <a class="google-full">
        <div id="google-login-btn">
          <img
            src="@/assets/images/google-icon.svg"
            alt="google logo"
            class="google-logo"
          />
        </div>
        <span class="text" style="cursor: pointer">
          {{ $t('SSO_LOGIN') }}
        </span>
      </a>
    </div>
     <p class="lite-lp-popup-subtitle">
            <span>
                {{$t('OR')}}
            </span>
       </p>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'sso-header',

  computed: {
    ...mapState({
      originOfClient: state => state.base.originOfClient,
      lang: state => state.base.lang.localName
    })
  },

  methods: {
    goToGoogleSso () {
      this.$store.dispatch('goToGoogleSso')
    },
    goToIdmSso () {
      this.$store.dispatch('goToIdmSso')
    }
  }
}
</script>

<style>
</style>
